export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-result/index.js